<template>
<div>
    <v-row class="mb-7">
        <v-col lg="6" class="py-0">
            <v-toolbar flat style="background:transparent">
                <h2>Live Report</h2>
                <v-spacer></v-spacer>
                <!--<v-btn elevation="0" @click="openDialog" color="primary">
                    <v-icon left>mdi-plus</v-icon>เลือกการถ่ายทอดสด
                </v-btn>-->
            </v-toolbar>
        </v-col>
        <v-col lg="6" class="py-0">
            <v-toolbar flat style="background: transparent" class="content-right">
            <v-btn
            @click="goToCourseDetail"
            elevation="0"
            class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
            >
            {{
                $vuetify.lang.t(
                '$vuetify.courseManagement.courseReport.courseDetail'
                )
            }}
            </v-btn>
            </v-toolbar>
        </v-col>

    </v-row>
    <v-divider></v-divider>
    <div class=" header pa-5">
        <p class="mb-4">กำหนดช่วงเวลาที่ต้องการดูรายงาน</p>
        <v-row>
            <v-col lg="1" class="py-0 text-center">
                <p> ครั้งที่ </p>
            </v-col>
            <v-col lg="3" class="py-0">
                <p> วันที่เริ่ม</p>
            </v-col>
            <v-col lg="2" class="py-0">
                <p> เวลาที่เริ่ม</p>
            </v-col>
            <v-col lg="3" class="py-0">
                <p>วันที่สิ้นสุด</p>
            </v-col>
            <v-col lg="2" class="py-0">
                <p> เวลาที่สิ้นสุด</p>
            </v-col>
            <v-col lg="1" class="py-0 text-center">

            </v-col>

        </v-row>
        <v-row v-for="(item,index) in date" :key="index">
            <v-col lg="1 text-center py-0">
                <p class="mb-0"> {{index+1}}</p>
            </v-col>
            <v-col lg="3" class="py-0">
                <v-menu ref="menu" v-model="item.menu_start_date" :close-on-content-click="false" :return-value.sync="item.date_start" transition="scale-transition" offset-y min-width="290px" background-color="white">
                    <template v-slot:activator="{ on }">
                        <v-text-field height="34px" v-model="item.date_start" label persistent-hint background-color="white" readonly outlined v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="item.date_start" no-title :max="nowDate" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="item.menu_start_date = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu[index].save(item.date_start)">OK</v-btn>
                    </v-date-picker>
                </v-menu>

            </v-col>
            <v-col lg="2" class="py-0">
                <div class="d-flex">
                    <v-text-field outlined v-model="item.hh_start" background-color="white"></v-text-field>
                    <p class="mb-0 mx-2">:</p>
                    <v-text-field outlined v-model="item.mm_start" background-color="white"></v-text-field>
                </div>

            </v-col>
            <v-col lg="3" class="py-0">

                <v-menu ref="menuend" v-model="item.menu_end_date" :close-on-content-click="false" :return-value.sync="item.date_end" transition="scale-transition" offset-y min-width="290px" background-color="white">
                    <template v-slot:activator="{ on }">
                        <v-text-field height="34px" v-model="item.date_end" label persistent-hint background-color="white" readonly outlined v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="item.date_end" no-title :max="nowDate" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="item.menu_end_date = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menuend[index].save(item.date_end)">OK</v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col lg="2" class="py-0">
                <div class="d-flex">
                    <v-text-field outlined v-model="item.hh_end" background-color="white"></v-text-field>
                    <p class="mb-0 mx-2">:</p>
                    <v-text-field outlined v-model="item.mm_end" background-color="white"></v-text-field>
                </div>
            </v-col>
            <v-col lg="1" class="py-0">
                <v-btn color="error" class="white--text" x-small outlined fab :disabled="date.length<=1" @click="removeTime(index)">
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-center py-0">
                <v-btn color="success" class="white--text" x-small outlined fab @click="addTime()">
                    <v-icon dark>mdi-plus</v-icon>
                </v-btn>
            </v-col>

        </v-row>
        <div class="text-center mt-9 mb-4">
            <v-btn color="primary" @click="saveTime">

                <v-icon class="mr-2" style="font-size:21px">mdi-format-list-bulleted-square</v-icon>

                ดูรายงาน
            </v-btn>
        </div>
    </div>
    <div class="bg-custom  py-7" v-show="show_report">
        <v-row>
            <v-col class="ml-5 xs-full-width text-right">
                <v-btn @click="exportCertification" class="clickable pl-5 pr-5 mr-5 xs-full-width font-weight-light body-2 button-secondary v-btn theme--light elevation-0 v-size--default">
                    <v-icon left class="icon-color-inherit">mdi-microsoft-excel</v-icon>Export Report
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table :loading="loading" :headers="headers" :items-per-page="params.limit" :hide-default-header="true" hide-default-footer :items="users" class="pa-mb-5 mx-3 font-weight-light table-haveboder">
            <template v-slot:header="{ props }">
                <thead class="v-data-table-header">
                    <tr>
                        <th style=" border-right: thin solid rgba(0, 0, 0, .12);" v-for="(item,index) in props.headers" :key="index">{{item.text}}</th>

                    </tr>

                </thead>
            </template>
            <template v-slot:item="{ item }">
                <tr>
                    <td>{{item.username}}</td>
                    <td>{{item.fullName}}</td>
                    <td>{{item.email}}</td>
                    <td v-for="(item_his,index) in item.history" :key="index">

                        <v-icon :color="item_his.isSuccess===true?'success':'red'">{{ item_his.isSuccess===true?'mdi-check':'mdi-close'}}</v-icon>
                    </td>
                </tr>
            </template>

        </v-data-table>
        <div class="pt-3 pr-3 pb-5 text-center">
            <v-pagination v-model="params.page" :length="pageCount" @input="changePage" color="rgb(66, 154, 216)"></v-pagination>
        </div>
    </div>

    <v-dialog v-model="time_dialog" max-width="950px">
        <v-card>
            <v-toolbar flat dark color="rgb(51, 97, 137)">
                <v-spacer></v-spacer>
                <v-toolbar-title class="font-weight-light text-center ml-5 text-capitalize">เลือกการถ่ายทอดสด</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="pt-5">
                <div class="header">
                    <v-row>
                        <v-col lg="1" class="py-0 text-center">
                            <p> ครั้งที่ </p>
                        </v-col>
                        <v-col lg="3" class="py-0">
                            <p> วันที่เริ่ม</p>
                        </v-col>
                        <v-col lg="2" class="py-0">
                            <p> เวลาที่เริ่ม</p>
                        </v-col>
                        <v-col lg="3" class="py-0">
                            <p>วันที่สิ้นสุด</p>
                        </v-col>
                        <v-col lg="2" class="py-0">
                            <p> เวลาที่สิ้นสุด</p>
                        </v-col>
                        <v-col lg="1" class="py-0 text-center">

                        </v-col>

                    </v-row>
                    <v-row v-for="(item,index) in date" :key="index">
                        <v-col lg="1 text-center py-0">
                            <p class="mb-0"> {{index+1}}</p>
                        </v-col>
                        <v-col lg="3" class="py-0">
                            <v-menu ref="menu" v-model="item.menu_start_date" :close-on-content-click="false" :return-value.sync="item.date_start" transition="scale-transition" offset-y min-width="290px" background-color="white">
                                <template v-slot:activator="{ on }">
                                    <v-text-field height="34px" v-model="item.date_start" label persistent-hint background-color="white" readonly outlined v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="item.date_start" no-title :max="nowDate" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="item.menu_start_date = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu[index].save(item.date_start)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>

                        </v-col>
                        <v-col lg="2" class="py-0">
                            <div class="d-flex">
                                <v-text-field outlined v-model="item.hh_start"></v-text-field>
                                <p class="mb-0 mx-2">:</p>
                                <v-text-field outlined v-model="item.mm_start"></v-text-field>
                            </div>

                        </v-col>
                        <v-col lg="3" class="py-0">

                            <v-menu ref="menuend" v-model="item.menu_end_date" :close-on-content-click="false" :return-value.sync="item.date_end" transition="scale-transition" offset-y min-width="290px" background-color="white">
                                <template v-slot:activator="{ on }">
                                    <v-text-field height="34px" v-model="item.date_end" label persistent-hint background-color="white" readonly outlined v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="item.date_end" no-title :max="nowDate" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="item.menu_end_date = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menuend[index].save(item.date_end)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col lg="2" class="py-0">
                            <div class="d-flex">
                                <v-text-field outlined v-model="item.hh_end"></v-text-field>
                                <p class="mb-0 mx-2">:</p>
                                <v-text-field outlined v-model="item.mm_end"></v-text-field>
                            </div>
                        </v-col>
                        <v-col lg="1" class="py-0">
                            <v-btn color="error" width="100%" class="white--text" :disabled="date.length<=1" @click="removeTime(index)">
                                <v-icon dark>mdi-minus</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="text-center py-0">
                            <v-btn color="success" class="white--text " @click="addTime()">
                                <v-icon dark>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>

                    </v-row>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="closeDialog">ยกเลิก</v-btn>
                <v-btn color="primary" @click="saveTime">ดูรายงาน</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>

</div>
</template>

<script>
import XLSX from "xlsx";
import {
    getCourseById
} from "@/service/course/course";
import {
    getLiveReport
} from "@/service/course/report";
//import downloadexcel from "vue-json-excel";
export default {
    /*components: {
        downloadexcel
    },*/
    data() {
        return {
            show_report: false,
            loading: false,
            date_start: '',
            // current: 1,
            time_dialog: false,
            nowDate: new Date().toISOString().slice(0, 10),
            date: [],
            idCourse: null,
            menu: false,
            params: {},
            pageCount: 1,
            headers: [{
                    text: "USERNAME",
                    align: "start",
                    sortable: false,
                    value: "username",
                    width: 150
                },
                {
                    text: "NAME",
                    value: "fullName",
                    align: "start",
                    sortable: false,
                    width: 150
                },

                {
                    text: "EMAIL",
                    value: "email",
                    align: "start",
                    sortable: false,
                    width: 150
                },

            ],
            fileExcelName: "certificate.xls",
            json_fields: {},
            users: [],
            text: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        };
    },
    methods: {
        async initialize() {
            this.params = {
                sort: 'created_at',
                sortby: -1,
                page: 1,
                limit: 100,
                datelivestream: [],
                active: null,
                idlivestream: null
            }
            console.log('getCourseDetail')
            this.idCourse = this.$route.query.id
            console.log(' this.idCourse', this.idCourse)
            if (this.idCourse != null) {
                let params = {
                    id: this.idCourse
                };

                await this.getCourseDetail(params);

            }
        },
        openDialog() {
            this.time_dialog = true;
        },
        closeDialog() {
            this.time_dialog = false;
            this.date = [{
                date_start: this.date_start,
                date_end: new Date().toISOString().substr(0, 10),
                hh_start: new Date().getHours(),
                mm_start: new Date().getMinutes(),
                hh_end: new Date().getHours(),
                mm_end: new Date().getMinutes(),
                menu_start_date: false,
                menu_end_date: false

            }]
        },
        addTime: function () {
            this.date.push({
                date_start: this.date_start,
                date_end: new Date().toISOString().substr(0, 10),
                hh_start: new Date().getHours(),
                mm_start: new Date().getMinutes(),
                hh_end: new Date().getHours(),
                mm_end: new Date().getMinutes(),
                menu_start_date: false,
                menu_end_date: false
            })
            //   if (this.type == "text") {
            //     this.answer.push({ text: "" });
            //   } else {
            //     this.answer.push({ image: "" });
            //   }
            //   console.log(this.answer);
        },
        removeTime(index) {
            console.log(index)

            this.date.splice(index, 1)

        },
        async saveTime() {
            this.time_dialog = false
            let datelive = [];
            this.headers = [{
                    text: "USERNAME",
                    align: "start",
                    sortable: false,
                    value: "username",
                    width: 150
                },
                {
                    text: "NAME",
                    value: "fullName",
                    align: "start",
                    sortable: false,
                    width: 150
                },

                {
                    text: "EMAIL",
                    value: "email",
                    align: "start",
                    sortable: false,
                    width: 150
                },

            ];

            for (let i = 0; i < this.date.length; i++) {
                let start = this.date[i].date_start + ' ' + this.date[i].hh_start + ':' + this.date[i].mm_start;
                let end = this.date[i].date_end + ' ' + this.date[i].hh_end + ':' + this.date[i].mm_end;
                console.log('start', start)
                let start_time = Math.floor((new Date(start)).getTime());
                let end_time = Math.floor((new Date(end)).getTime());
                datelive.push({
                    starttime: start_time,
                    endtime: end_time
                })
                this.headers.push({
                    text: this.date[i].date_start,
                    value: "history",
                    align: "start",
                    sortable: false,
                })
                // let endtime = Math.floor((new Date('2020-08-15 12:00')).getTime())
            }
            console.log(datelive)
            this.params.datelivestream = datelive;
            console.log(' this.params.datelivestream', this.params.datelivestream)
            this.getReport();

        },
        async getCourseDetail(param) {
            let detail = await getCourseById(param);
            console.log('detail', detail);
            this.date_start = new Date(detail.Live_LivestreamsV2[0].startTime).toISOString().substr(0, 10)
            console.log('this.date_start', this.date_start)
            this.live = detail.Live_LivestreamsV2[0]._id
            this.params.idlivestream = detail.Live_LivestreamsV2[0]._id;
            this.date = [{
                date_start: this.date_start,
                date_end: new Date().toISOString().substr(0, 10),
                hh_start: new Date(detail.Live_LivestreamsV2[0].startTime).getHours(),
                mm_start: new Date(detail.Live_LivestreamsV2[0].startTime).getMinutes(),
                hh_end: new Date().getHours(),
                mm_end: new Date().getMinutes(),
                menu_start_date: false,
                menu_end_date: false

            }]
        },
        async getReport() {
            this.loading = true
            this.users = [];
            let list = await getLiveReport(this.params)
            console.log('list', list)
            this.pageCount = list.maxPage
            this.show_report = true
            await list.data.forEach(async (user) => {
                this.users.push({
                    id: user.student._id,
                    fullName: user.student.firstName + " " + user.student.lastName,
                    email: user.student.email,
                    username: user.student.username,
                    history: user.history
                });

            });
            this.loading = false;
        },
        async changePage(page) {
            this.params.page = page;
            await this.getReport();
        },
        async exportCertification() {
            // for (let k = 0; k < this.headers.length; k++) {
            //     this.json_fields[this.headers[k].text] = this.headers[k].text
            // }
            // console.log('this.json_fields', this.json_fields)
            const result = await getLiveReport({
                ...this.params,
                limit: 1000,
                page: 1
            });
            let users = [];

            for (let i = 0; i < result.data.length; i++) {
                let info = {
                    username: result.data[i].student.username,
                    fullname: result.data[i].student.firstName + ' ' + result.data[i].student.lastName,
                    email: result.data[i].student.firstName,
                }

                for (let j = 0; j < result.data[i].history.length; j++) {
                    // info[`live`(j + 1)] = result.data[i].history[j].isSuccess
                    info[`live` + (j + 1)] = result.data[i].history[j].isSuccess
                    console.log('info', info)
                }
                users.push(info)
            }
            console.log('users', users)
            const dataWS = XLSX.utils.json_to_sheet(users);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS);
            XLSX.writeFile(wb, "live_culi.xlsx");

            //  return users;
        },
        goToCourseDetail(){
            this.$router.push({
                path: '/course/detail',
                query: {
                    id: this.$route.query.id,
                    step: 1,
                },
            });
        }

    },
    async mounted() {

        console.log('init')
        await this.initialize();
    }

}
</script>

<style scoped>
.button-secondary {
    color: rgb(65, 65, 65);
    border: 1px solid rgb(195, 195, 195);
}
</style>
<style lang="scss">
  .content-right {
    .v-toolbar__content, .v-toolbar__extension {
      justify-content: flex-end;
    }
  }
</style>
